export const AVG_DAYS_IN_POSITION = {
  prefix: "",
  value: 42,
  suffix: "",
  change: 0,
  changeSuffix: "",
  decimals: 0,
};
